"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function constructError(constructorFn, error, meta) {
  if (error instanceof Error) {
    return new constructorFn(error.message, error);
  }

  if (error instanceof String || typeof error === 'string') {
    return new constructorFn('' + error, meta);
  }

  if (typeof error === 'object') {
    if (typeof error['error'] !== 'undefined') {
      // Build an Error using the `error` property and use the input as `meta`
      return constructError(constructorFn, error['error'], error);
    } else if (typeof error['toString'] === 'function') {
      return new constructorFn(error.toString(), error);
    } else if (typeof error['toLocalString'] === 'function') {
      return new constructorFn(error.toLocalString(), error);
    }
  }

  return new constructorFn('Undefined error', error);
}
/**
 * Build an error of the given `constructorFn`
 *
 * @param {ErrorConstructorFn<E extends ApiError>} constructorFn
 * @param {ErrorInput} error
 * @return {E}
 */


function buildError(constructorFn, error) {
  return constructError(constructorFn, error, undefined);
}

exports.buildError = buildError;

var ApiError =
/** @class */
function () {
  function ApiError(message, meta, name) {
    if (name === void 0) {
      name = 'ApiError';
    }

    this.message = message;
    this.meta = meta;
    this.name = name;
  }

  return ApiError;
}();

exports.ApiError = ApiError;